import { GroupCustomer, IReportFilter } from "../../api/reportCustomer/reportCustomerApi"
import { formatPrice } from "../../until"

interface Prop {
  infoReportCustomer?: GroupCustomer
  defaulFilter?: IReportFilter

  hadleTogleGroupCus: (value: number) => void
}
export const TableGroupCustomer: React.FC<Prop> = ({
  infoReportCustomer, defaulFilter,
  hadleTogleGroupCus
}) => {
  return (
    <div className='d-flex flex-column gap-6 h-200-px overflow-y-scroll custom-tfoot'>
      <table className='w-full '>
        <thead>
          <tr>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Tên nhóm</th>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Số khách hàng</th>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Khách đã chăm sóc</th>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Khách chưa chăm sóc</th>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Tổng số lần chăm sóc</th>
            <th className='text-start text-base text-344054 fw-500 font-medium'>Tỉ lệ chăm sóc (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr className="h-4"><td colSpan={6}></td></tr>
        </tbody>
        <tbody >
          {infoReportCustomer?.list?.map((item, index) => (
            <tr key={index} >
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
                onClick={() => hadleTogleGroupCus(item.id)}
              >
                {item.title}
              </td>
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
              >
                {formatPrice(item.totalCustomersInGroup.toLocaleString())}
              </td>
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
              >
                {formatPrice(item.totalCaredCustomersInGroup.toLocaleString())}
              </td>
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
              >
                {formatPrice(item.totalUncaredCustomersInGroup.toLocaleString())}
              </td>
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
              >
                {formatPrice(item.totalCareVisitsInGroup.toLocaleString())}
              </td>
              <td
                className={`text-sm font-regular  fw-400 cursor-pointer ${defaulFilter?.idgroupCustomer?.includes(item.id) ? "text-096DD9" : "text-667085"}`}
              >
                {formatPrice(item.carePercentageInGroup)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className='text-start text-base text-344054 fw-500 font-medium'>Tổng</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'>{formatPrice(infoReportCustomer?.summary?.totalCustomersInGroupAll)}</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'>{formatPrice(infoReportCustomer?.summary?.totalCaredCustomersInGroupAll)}</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'>{formatPrice(infoReportCustomer?.summary?.totalUncaredCustomersInGroupAll)}</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'>{formatPrice(infoReportCustomer?.summary?.totalCareVisitsInGroupAll)}</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'>{"-"}</td>
            <td className='text-start text-base text-344054 fw-500 font-medium'></td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
